import React from 'react';

const DwriReportTab = () => {
    return (
        <div className="utah-design-system">
             <h3>Report</h3>
             <p>Report content goes here.</p>
        </div>
    );
};

export default DwriReportTab;